import { useContext, useEffect, useState } from 'react';
import { LinearProgress } from '@mui/material';
import UploadZone from './UploadZone';
import { ITrainingSet } from '../../types/my-types';
import { UploadContext } from './UploadContext';

interface IUploadProps {
  trainingSet?: ITrainingSet;
  trainingSetError?: boolean;
  isExtraction: boolean;
  isUpdate?: boolean;
  dismissModal: () => void;
}

const Upload = (props: IUploadProps) => {
  const { uploading, label, totalAcceptedDocs, totalUploadedDocs, totalFailedDocs, setOption } =
    useContext(UploadContext);
  const { trainingSet, trainingSetError, isExtraction, isUpdate, dismissModal } = props;
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (totalAcceptedDocs > 0 && (totalUploadedDocs > 0 || totalFailedDocs > 0)) {
      const step = 100 / totalAcceptedDocs;
      setProgress(step * (totalUploadedDocs + totalFailedDocs));
    }
  }, [setProgress, totalAcceptedDocs, totalUploadedDocs, totalFailedDocs]);

  if (!uploading) {
    return (
      <div
        id="upload"
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
        }}
      >
        <div style={{ flex: 1, minWidth: 0 }}>
          <UploadZone
            trainingSetError={trainingSetError}
            trainingSet={trainingSet}
            isExtraction={isExtraction}
            isUpdate={isUpdate}
            dismissModal={dismissModal}
            setOption={setOption}
          />
        </div>
        <span style={{ fontFamily: 'Roboto', color: '#5f6d7e', fontSize: '14px', flexShrink: 0 }}>
          or
        </span>
        <UploadZone
          type="button"
          trainingSetError={trainingSetError}
          trainingSet={trainingSet}
          isExtraction={isExtraction}
          isUpdate={isUpdate}
          dismissModal={dismissModal}
          setOption={setOption}
        />
      </div>
    );
  } else {
    if (totalUploadedDocs >= totalAcceptedDocs) {
      return (
        <div style={{ width: '100%' }}>
          <p>Creating {label}</p>
          <LinearProgress />
        </div>
      );
    }

    return (
      <div style={{ width: '100%' }}>
        <p>{`Uploading ${totalUploadedDocs ? totalUploadedDocs : 1} of ${totalAcceptedDocs}`}</p>
        <LinearProgress variant="determinate" value={progress} />
      </div>
    );
  }
};

export default Upload;
